import BackendServices from "./BackendServices";

let apiClient;
try {
  apiClient = require("./http/apiClient").default;
} catch (_) {
  apiClient = null;
}

const http = {
  get: (url, config) =>
    apiClient ? apiClient.get(url, config) : BackendServices.get(url),
  post: (url, body, config) =>
    apiClient ? apiClient.post(url, body, config) : BackendServices.post(url, body),
};

const BASE = "/api/v1/criptobnb";
const SWAP_BASE = "/api/v1/swap";

function unwrap(res) {
  return res?.data ?? res;
}

function parseMaybeJSON(val) {
  if (typeof val === "string") {
    try {
      return JSON.parse(val);
    } catch {
      return val;
    }
  }
  return val;
}

async function tryGet(path, { casing = "lower", label = "" } = {}) {
  const res = await http.get(path, { casing });
  const raw = unwrap(res);
  const data = parseMaybeJSON(raw);
  console.log(`📥 GET ${label} (${casing}) →`, { path, raw, parsed: data });
  return data;
}

async function tryPost(path, body, { casing = "lower", label = "" } = {}) {
  const res = await http.post(path, body, { casing });
  const raw = unwrap(res);
  const data = parseMaybeJSON(raw);
  console.log(`📤 POST ${label} (${casing}) →`, { path, body, raw, parsed: data });
  return data;
}

async function getWithVariants(pathEncoded, pathRaw, label) {
  try {
    return await tryGet(pathEncoded, { casing: "lower", label });
  } catch (e) {
    if (e?.status !== 400) throw e;
  }
  try {
    return await tryGet(pathEncoded, { casing: "title", label });
  } catch (e) {
    if (e?.status !== 400) throw e;
  }
  try {
    return await tryGet(pathRaw, { casing: "lower", label });
  } catch (e) {
    if (e?.status !== 400) throw e;
  }
  return await tryGet(pathRaw, { casing: "title", label });
}

async function postWithVariants(path, body, label) {
  try {
    return await tryPost(path, body, { casing: "lower", label });
  } catch (e) {
    if (e?.status !== 400) throw e;
  }
  return await tryPost(path, body, { casing: "title", label });
}

const RampsService = {
  async getBalance(email) {
    if (!email) throw new Error("Falta email para consultar saldo");
    const enc = encodeURIComponent(email);
    const encodedPath = `${BASE}/subaccounts/${enc}/balance`;
    const rawPath = `${BASE}/subaccounts/${email}/balance`;
    const data = await getWithVariants(encodedPath, rawPath, "balance");
    const list = Array.isArray(data?.balances) ? data.balances : [];
    const byAsset = Object.fromEntries(
      list.map(i => [String(i.asset || "").toUpperCase(), i])
    );
    const usdtFree = Number(byAsset.USDT?.free ?? 0);
    return { usdtFree, balances: list };
  },

  async getDepositAddress(email) {
    if (!email) throw new Error("Falta email para endereço de depósito");
    const enc = encodeURIComponent(email);
    const encodedPath = `${BASE}/subaccounts/${enc}/deposit-address`;
    const rawPath = `${BASE}/subaccounts/${email}/deposit-address`;
    const data = await getWithVariants(encodedPath, rawPath, "deposit-address");
    return data;
  },

  async postWithdrawPix(email, withdrawalList) {
    if (!email) throw new Error("Falta email para saque PIX");
    if (!Array.isArray(withdrawalList) || withdrawalList.length === 0) {
      throw new Error("Lista de saques vazia");
    }
    const enc = encodeURIComponent(email);
    const path = `${BASE}/subaccounts/${enc}/withdraw-pix`;
    const data = await postWithVariants(path, { withdrawalList }, "withdraw-pix");
    return data;
  },

  async createCriptoQuote({
    email,
    side = "buy",
    quantity,
    baseCurrency = "usdt",
    quoteCurrency = "brl",
  }) {
    if (!email) throw new Error("Falta email para cotação");
    if (!quantity && quantity !== 0) throw new Error("Falta quantidade para cotação");
    const payload = {
      email,
      side,
      quantity: String(quantity),
      base_currency: String(baseCurrency).toLowerCase(),
      quote_currency: String(quoteCurrency).toLowerCase(),
    };
    const data = await tryPost(
      `${SWAP_BASE}/createcriptoquote`,
      payload,
      { casing: "lower", label: "createcriptoquote" }
    );
    return data;
  },

  async getUsdtQuoteBRL() {
    try {
      const data = await tryGet(`/api/v1/quotes/usdt-brl`, {
        casing: "lower",
        label: "quote-usdt-brl",
      });
      return data;
    } catch (_) {
      return { pair: "USDT-BRL", price: 5.0 };
    }
  },
};

export default RampsService;








